import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import shortId from 'shortid';
import DetailsPanel from '../DetailsPanel';
import messages from './messages';

const WireInstructionsPanel = ({
  wireInstructions,
}) => (
  <DetailsPanel title={<FormattedMessage {...messages.instructions} />}>
    <div data-test-handle="wireInstructions">
      {wireInstructions.map((instruct) => <div key={`wire-instruction-line-${shortId.generate()}`}>{instruct}</div>)}
    </div>
  </DetailsPanel>
);

WireInstructionsPanel.propTypes = {
  wireInstructions: PropTypes.array,
};

WireInstructionsPanel.defaultProps = {
  wireInstructions: [],
};

export default WireInstructionsPanel;



// WEBPACK FOOTER //
// ./src/components/WireInstructionsPanel/index.js